import { post } from '@api/request';

export const fetchDailyLog = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  const url = `${mobileService}/mobile/statistics/dailylog`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchProductivity = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  const url = `${mobileService}/mobile/statistics/productivity`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};
